import React, { useCallback, ChangeEventHandler, useRef, FC } from 'react';

import { ClassName } from 'Modules/ui/utils';

import { Button, ButtonVariant } from '../Button';
import styles from './index.module.scss';


export type FilePickerButtonProps = ClassName & {
    variant: ButtonVariant;
    /*
     * File types, e.g. '.xlsx', '.xml', 'text/xml',
     */
    accept: string;
    multiple?: boolean;
    disabled?: boolean;
    onPick: (files: File[]) => void;
};

export const FilePickerButton: FC<FilePickerButtonProps> = ({
    children,
    className,
    variant,
    onPick,
    disabled,
    ...inputProps
}) => {
    const input = useRef<HTMLInputElement>();
    const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
        ({ target }) => onPick(Array.from(target.files)),
        [onPick],
    );
    const open = useCallback(
        () => {
            input.current.value = '';
            input.current.click();
        },
        [],
    );
    return (
        <Button variant={variant} className={className} onClick={open} disabled={disabled}>
            <input
                ref={input}
                {...inputProps}
                className={styles.input}
                type='file'
                tabIndex={-1}
                onChange={onChange}
            />
            {children}
        </Button>
    );
};
